import React from 'react';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { namespace, actions, selectors } from './';

import Filters from '../../../shared/filters/main';
import Search from '../../../shared/search/main';

import TableHead from '../../../shared/new-table/components/TableHead';
import TableBody from '../../components/table-body';

import { renderDefaultTH } from '../../../shared/new-table/renderers';

import MailingRow from './components/mailing-row';
import MailingSubRow from './components/mailing-sub-row';

import wrapMain from '../../wrap-main';

import Calendar from '../../../shared/calendar/main';
import Checkbox from '../../../shared/form-elements/checkbox';

import { enum as permissions } from '../../../../../../../enums/admin-permissions';

import headers from './headers';

function MailingList({ intl, check, rows, pagination, removeBySplitTestId, ...props }) {
	return (
		<div className='mailings-new-list'>
			{check(permissions.mailingsCreate) && (
				<div className='mailings-new-navigation'>
					<Link
						className='ui-btn ui-btn-primary'
						to='/mailings-new/triggered-mailings/editor'
					>
						{intl('Create triggered mailing')}
					</Link>
				</div>
			)}
			<div>
				<div className='clearfix'>
					<Filters
						intl={intl}
						{...props.filters}
						filters={props.filters} // for crutch support
					/>
				</div>
				<div className='ui-control-bar'>
					<div className='ui-control-bar__item modify-item---search'>
						<div className='ui-control-bar__item-position'>
							<Search
								form={`${namespace}SearchForm`}
								action={props.search}
								autoFocus={true}
								initialValues={props.searchData}
							/>
						</div>
					</div>
					<div className='ui-control-bar__item modify-item---checkbox'>
						<div className='ui-control-bar__item-position'>
							<Checkbox
								input={{
									name: 'unique',
									value: props.isUniqueEventsShowed,
									onChange: props.toggleIsUniqueEventsShowed
								}}
								placeholder='unique events for dates:'
							/>
						</div>
					</div>
					<div className='ui-control-bar__item modify-item---calendar'>
						{props.isUniqueEventsShowed && (
							<div className='ui-control-bar__item-position'>
								<Calendar
									intl={intl}
									{...props.calendar}
									onInit={props.calendar.calendarInit}
									onToggle={props.calendar.calendarToggle}
									onChange={props.calendar.calendarChange}
									onApply={props.calendar.calendarApply}
								/>
							</div>
						)}
					</div>
					<div className='ui-control-bar__item'>
						<div className='ui-control-bar__item-position'>
							<button
								className='ui-btn ui-btn-primary'
								onClick={props.apply}
							>
								{intl('Apply')}
							</button>
							<button
								className='ui-btn ui-btn-secondary ui-icon-clear'
								onClick={props.clear}
							/>
						</div>
					</div>
				</div>
			</div>
			<table className='new-table mailings-new-list-table'>
				<TableHead
					headers={headers}
					renderTH={renderDefaultTH}
				/>
				<TableBody
					rows={formatRows(rows, props.isUniqueEventsShowed)}
					row={MailingRow}
					subRow={MailingSubRow}
					removeBySplitTestId={removeBySplitTestId}
				/>
			</table>
			{(rows.length < pagination.total) && (
				<div className='banners-button-wrapper'>
					<button
						className='ui-btn ui-btn-secondary banners-button'
						onClick={pagination.showMore}
					>
						{intl('Show more')}
					</button>
				</div>
			)}
		</div>
	);
}

function formatRows(rows, isUniqueEventsShowed) {
	return rows.map((mailing) => ({
		...mailing,
		list: mailing.list.map((template) => ({
			...template,
			opens: isUniqueEventsShowed ? template.unique_opens : template.opens,
			clicks: isUniqueEventsShowed ? template.unique_clicks : template.clicks,
			bounces: isUniqueEventsShowed ? template.unique_bounces : template.bounces,
			unsubs: isUniqueEventsShowed ? template.unique_unsubs : template.unsubs
		}))
	}));
}

function mapStateToProps(state) {
	return {
		rows: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		searchData: ({ search: selectors.select(state, 'search') }),
		isUniqueEventsShowed: selectors.select(state, 'isUniqueEventsShowed'),
		calendar: selectors.getCalendar(state),
		pagination: selectors.getPagination(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch),
		pagination: bindActionCreators(actions.pagination, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		},
		pagination: {
			...stateProps.pagination,
			...dispatchProps.pagination
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(wrapMain(MailingList));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/triggered-mailings/list/main.js